module.exports = __webpack_public_path__ + "static/media/copy-link-clipboard.7bf68760.svg";